// extracted by mini-css-extract-plugin
module.exports = {"invite-form":"Invite_invite-form__dCJYA","form":"Invite_form__UX5KG","logo":"Invite_logo__1C0s5"};